<template>
    <div class="cs4-cartCTA">
        <div class="cs4-cartCTA__title">
            {{ dictionary.cartCTATitle }}
        </div>
        <div class="cs4-cartCTA__eyes">
            <div class="cs4-cartCTA__eyes__eye cs4-cartCTA__eyes__eye--down cs4-cartCTA__eyes__eye--blink"></div>
            <div class="cs4-cartCTA__eyes__eye cs4-cartCTA__eyes__eye--down cs4-cartCTA__eyes__eye--blink"></div>

        </div>
        <div class="cs4-cartCTA__textWrapperBorder">
            <div class="cs4-cartCTA__textWrapper">
            <div class="cs4-cartCTA__text">
                {{ dictionary.cartCTAText }}
            </div>
        </div>
        </div>
        
    </div>
</template>

<script>
export default{
    name: 'CartCTA',
    props: ['dictionary'],
    emits: [],
    data(){
        return {

        }
    },
    methods: {
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>
$cubic: cubic-bezier(0.785, 0.135, 0.15, 0.86);
.cs4-cartCTA{
    width: 360px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 140px;
    padding: 0 0 20px;
    &__title{
        font-size: 15px;
        font-weight: 600;
        background: linear-gradient(90.49deg, #F94DD7 0.08%, #0577B7 97.66%);
        border-radius: 25px 25px 0 0;
        text-align: left;
        padding-left: 30px;
        padding: 2px 0 0px 30px;
    }

    &__text{
        font-size: 13px;
        font-weight: 600;
        background: -webkit-linear-gradient(180deg, #F94DD7 0.08%, #0577B7 97.66%);
        padding: 5px 10px;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        &Wrapper{
            background: white;
            margin: 3px;
            border-radius: 0 22px 22px 22px;

            &Border{
                background:linear-gradient(90.49deg, #F94DD7 0.08%, #0577B7 97.66%);
                grid-column: 1 /span 2;
                border-radius: 0 25px 25px 25px;
            z-index: 2;
            }
        }
    }

    &__eyes{
        position: relative;
        width: 140px;
        height: 30px;
        z-index: 1;
        line-height: 40px;
        font-size: 2rem;
        text-align: center;
        font-weight: 400;
        margin-bottom: -5px;
        &__eye{
            margin: 0 3px;
            top: 0;
            bottom: 0;
            background: #fff;
            width: 25px;
            height: 30px;
            border-radius: 50%;
            display: inline-block;
            overflow: hidden;
            position: relative;
            z-index: 1;
            &:before {
                content: '';
                margin: auto;
                width: 12px;
                height: 12px;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                border-radius: 50%;
                background: #4A4A4A;
                z-index: 1;
            }

            &--down:before {
                animation: sadb 4s $cubic infinite;
                animation-delay: 1s;
            }

            &--blink {
                animation: blink 4s $cubic infinite;
            }
        }
    }

    @keyframes sadb {
        0%, 10% {
            right: 0px;
        }
        20%, 40% {
            right: 48%;
        }
        50%, 100% {
            right: 0px;
        }
    }

    @keyframes blink {
	0%, 8% {
		height: 30px;
	}
	10%, 12% {
		height: 5px;
	}
	14%, 100% {
		height: 30px;
    }
    }
}
</style>